import src from "./douglas-elliman-logo-mobile.png";
export default { src: src, aspect: 7.3590, width: 574, height: 78 };